module.exports = require("./../../_gen/openfl/media/SoundMixer");